import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wallet, Clock, FileText, UserCircle, ShieldCheck, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";

const STEPS = [
  [Wallet, "Pay stubs", "Every finalized pay stub, with a PDF you can download or send to your bank or landlord. Only pay that has actually been processed shows up here."],
  [Clock, "Your time", "See the hours recorded for you this week, your time-clock punches, and your vacation and time-off-in-lieu balances."],
  [FileText, "Tax slips", "Your T4 appears here after year-end, and your Record of Employment if one is ever issued — no need to ask for copies."],
  [UserCircle, "Profile & changes", "Update your phone, address and emergency contact yourself. Name, banking, TD1 and other changes go to your employer for approval."],
  [ShieldCheck, "Private by design", "You only ever see your own information. Your SIN and bank account are always masked, and your employer can't see your password."],
];

// Shown once after the first sign-in; "Let's go" records welcome_seen_at so it never shows again.
export default function MeWelcome() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me").then((r) => setD(r.data)).catch(() => {}); }, []);
  const go = async () => { await api.post("/me/welcome-seen").catch(() => {}); navigate("/me", { replace: true }); };
  return (
    <div className="space-y-8" data-testid="me-welcome">
      <div>
        <div className="emp-label">{d?.company_name || ""}</div>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mt-2 text-slate-900">Welcome{d?.name ? `, ${d.name}` : ""} 👋</h1>
        <p className="text-base text-slate-500 mt-3 leading-relaxed">This is your employee portal. Here's what you can do — it takes about a minute to look around.</p>
      </div>
      <div className="space-y-3">
        {STEPS.filter(([, t]) => t !== "Your time" || d?.time_tracking !== false).map(([Icon, title, body], i) => (
          <div key={title} data-testid={`me-welcome-step-${i}`} className="emp-card flex gap-4" style={{ animation: `fadeUp .4s ease ${i * 80}ms both` }}>
            <div className="h-12 w-12 shrink-0 rounded-2xl bg-blue-50 text-blue-600 grid place-items-center"><Icon className="h-6 w-6" /></div>
            <div><div className="font-bold text-slate-900 text-lg">{title}</div><p className="text-sm text-slate-500 mt-1 leading-relaxed">{body}</p></div>
          </div>
        ))}
      </div>
      <button data-testid="me-welcome-go" onClick={go} className="emp-btn w-full text-base">Let's go <ArrowRight className="h-5 w-5" /></button>
      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}`}</style>
    </div>
  );
}
